import React, { Component } from 'react';
import { connect } from "react-redux";
import { apiCall } from "../helpers/MainHelper";

const withPermissions = (WrappedComponent) => {
    class WithPermissions extends Component {
        state = {
            userPermissions: [],
        };

        componentDidMount() {
            if (this.props.isLoggedin) {
                const cachedUser = JSON.parse(localStorage.getItem('user'));
                if (cachedUser && cachedUser.roles && cachedUser.roles[0] && cachedUser.roles[0].permissions) {
                    const permissions = cachedUser.roles[0].permissions.map(permission => permission.name);
                    this.setState({ userPermissions: permissions });
                } else {
                    this.fetchUserPermissions();
                }
            }
        }

        componentDidUpdate(prevProps) {
            if (!prevProps.isLoggedin && this.props.isLoggedin) {
                this.fetchUserPermissions();
            }
        }

        fetchUserPermissions = async () => {
            try {
                const response = await apiCall('business/settings/role/get-user-permissions', 'get', null);
                this.setState({ userPermissions: response });
                const cachedUser = JSON.parse(localStorage.getItem('user')) || {};
                cachedUser.roles = cachedUser.roles || [];
                cachedUser.roles[0] = cachedUser.roles[0] || {};
                cachedUser.roles[0].permissions = response;
                localStorage.setItem('user', JSON.stringify(cachedUser));
            } catch (error) {
                console.error('Error fetching user permissions:', error);
            }
        };

        render() {
            return <WrappedComponent
                {...this.props}
                userPermissions={this.state.userPermissions}
            />;
        }
    }

    const mapStateToProps = (state) => ({
        isLoggedin: state.loginReducer.isLoggedin,
    });

    return connect(mapStateToProps)(WithPermissions);
};

export default withPermissions;
